import I1 from "../components/img/f6.png";
import F1 from "../components/img/f1.png";
import C3 from "../components/img/friedchicken.png";
import I2 from "../components/img/f7.png";
import I3 from "../components/img/i7.png";
import I4 from "../components/img/i6.png";

export const heroData = [
  {
    id: 1,
    name: "6pc Fried",
    decp: "Crisp & Spicy",
    price: "105",
    imageSrc: C3,
  },
  {
    id: 2,
    name: "6pc Hot",
    decp: "Super Spicy",
    price: "105",
    imageSrc: I1,
  },
  {
    id: 3,
    name: "6pc BBQ",
    decp: "Sweet & Sticky",
    price: "105",
    imageSrc: F1,
  },
  {
    id: 5,
    name: "24pc Platter",
    decp: "Various Flavors",
    price: "420",
    imageSrc: I3,
  },
];    


export const categories = [
  {
    id: 1,
    name: "Wingz",
    urlParamName: "wingz",
  },
  {
    id: 2,
    name: "Strips",
    urlParamName: "strips",
  },
  {
    id: 3,
    name: "Gummies",
    urlParamName: "gummies",
  },
  {
    id: 4,
    name: "Baked",
    urlParamName: "baked",
  },
  {
    id: 5,
    name: "Favorites",
    urlParamName: "favors",
  },
  {
    id: 6,
    name: "Flowers",
    urlParamName: "flowers",
  },

  {
    id: 7,
    name: "Beverages",
    urlParamName: "beverages",
  },
];
